export default function DetalhesCliente({ clientes, selecionado }: iProps) {
    if (selecionado.value === "0") {
        return <div></div>
    }
    const id_cliente = Number(selecionado.value)
    const clienteAux = clientes.filter((reg:any) => reg.id_cliente === id_cliente)
    if (clienteAux.length === 0) {
        return <div></div>
    }
    const cliente = clienteAux[0]
    return (
        <div style={{ fontSize: "0.9em" }}>
            <p>Razão Social: {cliente.nome}</p>
            <p>CNPJ/CPF: {cliente.cnpj}{cliente.cpf} | Inscrição Municipal: {cliente.inscricao_municipal}</p>
            <p>Endereço: {cliente.logradouro} {cliente.numero} {cliente.bairro}, {cliente.complemento}, CEP {cliente.cep} {cliente.cidade}/{cliente.uf}</p>
            <p>Contato: Telefone {cliente.telefone} - Email {cliente.email}</p>
        </div>
    )
}
interface iProps {
    clientes: any[]
    selecionado: any
}